// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2HAoh","label":"CategoryService_label__3hK9g","location":"CategoryService_location__1bgVr"};